<template>
    <div class="PlayerPlaceholder object-fit" @mouseenter="onMouseEnter" @mouseleave="onMouseLeave">
        <video v-if="isDesktop" disablePictureInPicture class="PlayerPlaceholder-video" ref="preview" :src="video" loop="true" muted="true"></video>
        <picture>
            <source :srcset="desktopImage" media="(min-width: 768px)">
            <img class="PlayerPlaceholder-image object-fit-content" :src="mobileImage" alt="tbd">
        </picture>
        <div class="PlayerPlaceholder-infos">
            <div class="PlayerPlaceholder-titles">
                <div class="PlayerPlaceholder-subtitle">{{ client }}</div>
                <div class="PlayerPlaceholder-title"  v-html="titleFormated"></div>
            </div>
            <div class="PlayerPlaceholder-play">Play</div>
        </div>
    </div>
</template>

<script>

import Store from '@/stores/store.js'
import textWrapper from '@/utils/textWrapper.js'

export default {
    name: 'PlayerPlaceholder',
    props:{
        mobileImage: {
            type: String
        },
        desktopImage: {
            type: String
        },
        video: {
            type: String
        },
        client: {
            type: String,
            default: ''
        },
        title: {
            type: String,
            default: ''
        }
    },

    data() {
        return {
            previewPlaying: false,
            isDesktop: Store.isDesktop
        }
    },

    mounted() {
        if(Store.Safari >= 12 || isNaN(Store.Safari)) {
            this.$el.classList.add('hoverable')
        }
        else {
            this.$el.classList.add('safari')
        }
    },

    computed: {
        titleFormated(){
            return textWrapper(this.title, 100, 10, true);
        },
    },

    methods:{
        onMouseEnter(){
            if( !Store.isDesktop ) return;
            
            this.$refs.preview.currentTime = 0;
            this.$refs.preview.play();
            this.previewPlaying = true;
        },
        onMouseLeave(){
            if( !Store.isDesktop ) return;
            
            if( this.previewPlaying ){
                this.$refs.preview.pause();
                this.previewPlaying = false;
                this.$refs.preview.currentTime = 0;
            }
        }
    }
}
</script>


<style lang="scss">
    .PlayerPlaceholder{
        text-transform: uppercase;

        &-video{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: zindex(default);

            opacity: 0;
        }

        &-infos{
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            z-index: zindex(above);
        }

        &-client{
            position: absolute;
            top: 30px;
            left: 30px;
            font-size: rem(10px);
            text-transform: uppercase;
            color: color(white);
            letter-spacing: 3px;
            font-variation-settings: "wght" 500, "wdth" 80;
            @include respond-to(md){
                left: 20px;
                top: 20px;
            }
        }
        &-titles{
            position: absolute;
            bottom: 30px;
            left: 30px;
            max-width: 90%;
            @include respond-to(md){
                left: 20px;
                bottom: 20px;
            }
        }
        &-subtitle{
            font-size: rem(13px);
            letter-spacing: 3px;
            width: 100%;
            transition: 0.3s ease-out all;
            font-variation-settings: "wght" 550, "wdth" 70;    
            @include respond-to(md){
                margin-top: 10px;
                font-size: rem(12px);
                line-height: 1;
                letter-spacing: 1px;
                font-variation-settings: "wght" 450, "wdth" 20;
            }
        }
        &-title{
            margin-top: 15px;
            font-size: rem(41px);
            transition: 0.3s ease-out all;
            line-height: .8;
            width: 100%;
            font-variation-settings: "wght" 900, "wdth" 80;  
            @include respond-to(md){
                font-size: rem(16px);
                margin-top: 10px;
                font-variation-settings: "wght" 900, "wdth" 80;
            }
        }
        &-play{
            display: none;
            @include respond-to(md){
                position: absolute;
                bottom: 20px;
                right: 20px;
                display: block;
                font-size: rem(14px);
                font-variation-settings: "wght" 600, "wdth" 50;
                &:after{
                    content: "";
                    position: absolute;
                    bottom: -6px;
                    left: 0;
                    right: 0;
                    border-bottom: 3px solid color(white);
                }
            }
        }

        &-image{
            transform: scaleX(1);
        }
    }

    .hoverable {
        @include respond-to(desktop){      
            &:hover{
                
                .PlayerPlaceholder-video{
                    opacity: 1;    
                }

                .PlayerPlaceholder-subtitle{
                    font-variation-settings: "wght" 300, "wdth" 40;    
                }

                .PlayerPlaceholder-title{
                    font-variation-settings: "wght" 500, "wdth" 40;  
                }
            }
        }
    }

    .safari {
        @include respond-to(desktop){      
            .PlayerPlaceholder-subtitle{
                font-family: sans-serif;
            }

            .PlayerPlaceholder-title{
                font-family: sans-serif;
                font-weight: bold; 
            }
        }
    }
</style>
